import { AfterViewInit, Component, OnInit } from '@angular/core';
import { categoryDB } from '../../../../shared/tables/category';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LocalDataSource } from 'ng2-smart-table';
import { BrandDTO } from 'src/app/shared/models/model';
import { brandService } from 'src/app/shared/service/brand.service';
@Component({
    selector: 'app-brand',
    templateUrl: './brand.component.html',
    styleUrls: ['./brand.component.scss']
})
export class BrandComponent implements OnInit {
    public closeResult: string;
    public Source: LocalDataSource;

    public brandList: BrandDTO[]=[];
    public Brand: BrandDTO = new BrandDTO();

    constructor(private modalService: NgbModal,private branService:brandService) {
        this.Source = new LocalDataSource();
        this.Brand = new BrandDTO();
        
    this.branService.getBrands().subscribe(data => {
        this.brandList = data;
        this.Source = new LocalDataSource(this.brandList);
    });


        console.log(this.Source);
    }


    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    updateRecord(event) {
        this.Brand.brand1 = event.newData.brand1;
        this.Brand.es_brand = event.newData.es_brand;
        this.Brand.fr_brand = event.newData.fr_brand;
        this.Brand.idbrand = event.newData.idbrand;
        this.branService.updateBrand(this.Brand);
        event.confirm.resolve(event.newData);

    }

    deleteRecord(event) {
        this.Brand = new BrandDTO();
        console.log(event.data.idbrand);
        this.branService.deleteBrand(event.data.idbrand);
        event.confirm.resolve(event.newData);
    }


    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    public settings = {
        "mode": "inline",
        delete: {
            "confirmDelete": "true"
        },
        edit: { "confirmSave": "true" },
        actions: {
            position: 'right',
            update: true
        },
        columns: {
            idbrand: {
                title: 'IdBrand'
            },
            brand1: {
                title: 'Brand Description'
            }
        },
    };
    
    ngOnInit(): void {
        // this.Source = this.branService.getBrands();
        // console.log(this.Source);
    }

    onSubmit(brandForm) {
        debugger
        this.Brand = new BrandDTO();
        this.Brand.brand1 = brandForm.value["Brand"];
        this.Brand.fr_brand= brandForm.value["fr_Brand"];      
        this.Brand.es_brand= brandForm.value["es_Brand"];
        console.log(this.Brand);
        this.branService.addBrand(this.Brand);
        window.location.reload();
      }

}
function collapseAnimation() {
    throw new Error('Function not implemented.');
}
